import React from 'react';
import PropTypes from 'prop-types';

export default function IconComment({size = '55px', color = '#303030'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4248 2.39795H10.2227V7.79297H2.40527V8.9917C2.40527 9.15234 2.46973 9.29883 2.57422 9.40674C2.68359 9.52051 2.83691 9.59131 3.00684 9.59131H9.62109L12.0264 11.9888V2.99707C12.0264 2.66748 11.7559 2.39795 11.4248 2.39795ZM9.01953 5.99463V0.599609C9.01953 0.269531 8.74902 0 8.41895 0H0.601562C0.270508 0 0 0.269531 0 0.599609V8.9917L2.40527 6.59375H8.41895C8.6748 6.59375 8.89551 6.43164 8.98145 6.20459C9.00586 6.13916 9.01953 6.06836 9.01953 5.99463Z"
        fill={color}
      />
    </svg>
  );
}

IconComment.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
